<template>
  <modal name="orders-modal" height="auto" width="480px" :scrollable="true" :shiftY="0.2">
    <div class="close">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="$modal.hide('orders-modal')"  alt="">
    </div>
    <div class="modal-form">
      <div class="input-block">
        <h4>Заказы</h4>
        <loading-container :loading="loading" height="99">
          <table>
            <tr>
              <th>ID заказа</th>
              <th v-if="type == 1">Дата поступления</th>
              <th v-if="type == 2">Дата создания</th>
              <th>Сумма, руб</th>
              <th>Выбрать</th>
            </tr>
            <tr v-for="order in orders" :key="order.id">
              <td>{{order.id}}</td>
              <td v-if="type == 1">{{order.date}}</td>
              <td v-if="type == 2">{{$moment(order.created_at).format('DD.MM.YYYY')}}</td>
              <td>{{order.format_sum}}</td>
              <td>
                <app-checkbox
                        v-model="select_orders[order.id]"
                        white
                        table
                />
              </td>
            </tr>
          </table>
        </loading-container>
        <span class="text-danger text-sm" v-if="select_error">{{ select_error }}</span>
      </div>
      <div class="btn">
        <button style="margin-top: 16px;" @click="send()">Объеденить</button>
      </div>
    </div>
  </modal>
</template>

<script>

import AppCheckbox from "@/components/app-checkbox";
import LoadingContainer from "@/components/loading-container";

export default {
  name: "orders-modal",
  components: {AppCheckbox, LoadingContainer },
  data: ()=> ({
    orders: [],
    select_orders: [],
    id: '',
    type: '',
    select_error: '',
    loading: true
  }),
  methods: {
    open(order){
      if (order) {
        this.orders = [];
        this.loading = true;
        this.id = order.id;
        this.type = localStorage.getItem('type');
        this.getOrders();
        this.$modal.show('orders-modal');
      }
    },
    clear(){
      this.id = '';
    },
    send() {
      this.select_error = '';
      let error = true;
      for (let key in this.select_orders) {
        if (this.select_orders[key]) {
          error = false;
        }
      }
      if (error) {
        this.select_error = 'Выберите заказ';
      }

      if (!this.select_error) {
        this.save();
      }
    },
    getOrders() {
      if (localStorage.getItem('token')) {
        this.$http.post('/get-union-orders-variants', {
          token: localStorage.getItem('token'),
          order: this.id
        }).then(({data}) => {
          if (data.orders) {
            this.orders = data.orders
          }
        })
        .catch((error) => {
            console.log(error)
        })
        .finally(()=> {this.loading = false;})
      }
    },
    save(){
      let array = [];
      for (let key in this.select_orders) {
        if (this.select_orders[key]) {
          array.push(key);
        }
      }
      this.$validator.validateAll()
          .then(success => {
            if(success){
              if (localStorage.getItem('token')) {
                this.$http.post('/union-orders', {
                  token: localStorage.getItem('token'),
                  order: this.id,
                  orders: array
                }).then(({data}) => {
                  if (data.success) {
                    this.$toast.success('Заказы успешно объеденены');
                    this.$emit('saved');
                    this.$modal.hide('orders-modal');
                    this.clear();
                  }
                })
                .catch((error) => {
                    console.log(error)
                })
              }
            }
          })
    }
  }
}
</script>

<style scoped lang="scss">

.progress-bar-container {
  width: 140px;
  margin: 0px auto;
}

.btn{
  width: 100%;
  padding: 0;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  padding: 30px;
}
.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
input{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
</style>
